"use client";

import Link from "next/link";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#0b0b10] text-white">
      <div className="mx-auto w-full max-w-4xl px-6 py-16">
        <p className="text-[10px] uppercase tracking-[0.3em] text-white/60">
          Support
        </p>
        <h1 className="mt-3 text-3xl font-heading text-white">Contact Us</h1>
        <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/70">
          <p className="font-medium text-white/80">We&apos;re here to help</p>
          <p className="mt-1">Response time: Within 24-48 business hours</p>
        </div>

        <div className="mt-10 space-y-4 text-sm leading-relaxed text-white/70">
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Get in Touch</h2>
            <p className="mt-3">
              We&apos;re here to help! If you have any questions, concerns, or feedback, please don&apos;t
              hesitate to reach out to us through any of the channels below.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Contact Channels</h2>
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <div className="rounded-xl bg-white/5 p-5 hover:bg-white/10 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--hopp-gold)]/20">
                    <svg className="h-5 w-5 text-[var(--hopp-gold)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/60">Customer Support</p>
                    <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                      info@hopp.life
                    </a>
                  </div>
                </div>
                <p className="mt-3 text-white/60">For general inquiries, account issues, and support requests.</p>
              </div>

              <div className="rounded-xl bg-white/5 p-5 hover:bg-white/10 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-500/20">
                    <svg className="h-5 w-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/60">For Event Hosts</p>
                    <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                      info@hopp.life
                    </a>
                  </div>
                </div>
                <p className="mt-3 text-white/60">Need help with your event or have questions about hosting?</p>
              </div>

              <div className="rounded-xl bg-white/5 p-5 hover:bg-white/10 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-500/20">
                    <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/60">Business Inquiries</p>
                    <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                      info@hopp.life
                    </a>
                  </div>
                </div>
                <p className="mt-3 text-white/60">For partnerships, collaborations, and business-related inquiries.</p>
              </div>

              <div className="rounded-xl bg-white/5 p-5 hover:bg-white/10 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-500/20">
                    <svg className="h-5 w-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/60">Technical Support</p>
                    <a className="mt-1 block text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                      info@hopp.life
                    </a>
                  </div>
                </div>
                <p className="mt-3 text-white/60">Found a bug or experiencing technical difficulties?</p>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Office Address</h2>
            <div className="mt-4 flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-500/20">
                <svg className="h-5 w-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div>
                <p className="font-medium text-white">Innovation Hopp Experiences Private Limited</p>
                <p className="mt-1 text-white/60">
                  1101, Tower Crest Wing-1,<br />
                  Chandra Kala Colony, Durgapura,<br />
                  Jaipur, Rajasthan - 302018, India
                </p>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Grievance Officer</h2>
            <p className="mt-3">
              In accordance with the Consumer Protection Act, 2019 and the Consumer Protection (E-Commerce) Rules, 2020:
            </p>
            <div className="mt-4 rounded-xl bg-white/5 p-5">
              <div className="space-y-2">
                <p><span className="text-white/50">Name:</span> <span className="text-white">Nishchay Tolani</span></p>
                <p><span className="text-white/50">Designation:</span> <span className="text-white">Grievance Officer &amp; Nodal Officer</span></p>
                <p><span className="text-white/50">Email:</span>{" "}
                  <a className="text-[var(--hopp-gold)] hover:underline" href="mailto:nishchaytolani@hopp.life">
                    nishchaytolani@hopp.life
                  </a>
                </p>
                <p><span className="text-white/50">Hours:</span> <span className="text-white">Monday - Friday (09:00 a.m. to 18:00 p.m.)</span></p>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">Before You Contact Us</h2>
            <p className="mt-3">
              You might find answers to common questions in our help resources:
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link href="/legal/terms" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Terms and Conditions
              </Link>
              <Link href="/legal/privacy" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Privacy Policy
              </Link>
              <Link href="/refund" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                Refund Policy
              </Link>
              <Link href="/about" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm hover:bg-white/10 transition-colors">
                About Us
              </Link>
            </div>
          </section>

          <section className="rounded-2xl border border-[var(--hopp-gold)]/30 bg-[var(--hopp-gold)]/5 p-6">
            <p className="text-white/80">
              We aim to respond to all inquiries within 24-48 business hours. For urgent matters related to ongoing events, please include &quot;URGENT&quot; in your email subject line.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
